import type { Node, Connection } from '../types';

interface MapJsonResult {
  json: string;
  idMap: Record<string, string>;
  isEmpty: boolean;
}

export const buildMapJson = (nodes: Node[], connections: Connection[], focusedNodeId: string | null = null): MapJsonResult => {
  if (nodes.length === 0) return { json: '{"nodes":[]}', idMap: {}, isEmpty: true };

  const toShort: Record<string, string> = {};
  const idMap: Record<string, string> = {};

  nodes.forEach((n, i) => {
    const s = `n${i + 1}`;
    toShort[n.id] = s;
    idMap[s] = n.id;
  });

  interface JsonNode {
    id: string;
    type: string;
    title: string;
    summary?: string;
    parentId?: string;
    banned?: boolean;
  }

  const jsonNodes: JsonNode[] = nodes.map(n => {
    const parentConn = connections.find(c => c.to === n.id);
    const obj: JsonNode = {
      id: toShort[n.id],
      type: n.type,
      title: n.title,
      summary: n.summary,
    };
    if (parentConn && toShort[parentConn.from]) {
      obj.parentId = toShort[parentConn.from];
    }
    if (n.banned) obj.banned = true;
    return obj;
  });

  const crossLinks: { from: string; to: string }[] = [];
  connections.forEach(conn => {
    const fromShort = toShort[conn.from];
    const toShortId = toShort[conn.to];
    if (!fromShort || !toShortId) return;
    const targetNode = jsonNodes.find(n => n.id === toShortId);
    if (targetNode?.parentId === fromShort) return;
    crossLinks.push({ from: fromShort, to: toShortId });
  });

  const result: Record<string, unknown> = { nodes: jsonNodes };
  if (crossLinks.length > 0) result.crossLinks = crossLinks;
  if (focusedNodeId && toShort[focusedNodeId]) {
    result.focusedNodeId = toShort[focusedNodeId];
  }

  return { json: JSON.stringify(result, null, 2), idMap, isEmpty: false };
};
